import { render, staticRenderFns } from "./ProjectReadOnlyActivitiesView.vue?vue&type=template&id=77083bba&scoped=true&"
import script from "./ProjectReadOnlyActivitiesView.vue?vue&type=script&lang=js&"
export * from "./ProjectReadOnlyActivitiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77083bba",
  null
  
)

export default component.exports